<div class="details-container" *ngIf="item">
  <div class="header">
    <button class="back-button" (click)="goBack()"><i class="fas fa-arrow-left back-icon"></i></button>
    <h1 class="title">{{ decode(item.title) }}</h1>
    <div class="actions">
      <button class="action-button copy-button" (click)="copyUrlToClipboard()" title="Copy URL">
        <i class="fas fa-copy"></i>
      </button>
    </div>
    <div *ngIf="copySuccess" class="copy-success-message">
      URL copied to clipboard!
    </div>
  </div>

  <div class="details-content">
    <img [src]="item.field_cover_image && (item.field_cover_image.startsWith('http') ? item.field_cover_image : baseUrl + item.field_cover_image)" alt="{{ item.title }}" class="main-image">
    <div class="content" [innerHTML]="item.field_description">
    </div>
  </div>

  <div class="comment-section">
    <h3>Leave a Comment</h3>
    <form [formGroup]="commentForm">
      <textarea formControlName="comment" placeholder="Write your comment here..."></textarea>
      <div *ngIf="commentForm.controls['comment'].invalid && (commentForm.controls['comment'].dirty || commentForm.controls['comment'].touched)" class="validation-error">
        <div *ngIf="commentForm.controls['comment'].errors?.['required']">
          Comment is required.
        </div>
        <div *ngIf="commentForm.controls['comment'].errors?.['minlength']">
          Comment must be at least 10 characters long.
        </div>
        <div *ngIf="commentForm.controls['comment'].errors?.['maxlength']">
          Comment cannot exceed 200 characters.
        </div>
      </div>
      <div class="comment-buttons">
        <button type="submit" (click)="submitComment()" [disabled]="commentForm.invalid">Comment Anonymously</button>
      </div>
    </form>

    <div *ngIf="commentSubmitted" class="submission-message">
      Your comment has been received and is waiting approval from the site admin.
    </div>

    <div *ngIf="apiData" class="submission-message">
      <p>JSON data for API is created as:</p>
      <pre>{{ apiData | json }}</pre>
    </div>

    <div *ngIf="emailData" class="submission-message">
      <p>Email data prepared as:</p>
      <pre>{{ emailData | json }}</pre>
    </div>

    <hr class="separator-line">

    <div class="related-topics-section" *ngIf="relatedArticles.length > 0">
      <h3>Related topics</h3>
      <div class="related-topics-list">
        <div *ngFor="let article of relatedArticles" class="hot-topic-item" (click)="navigateToArticle(article)">
          <img [src]="article.field_cover_image && (article.field_cover_image.startsWith('http') ? article.field_cover_image : baseUrl + article.field_cover_image)" alt="{{ article.title }}" class="hot-topic-image">
          <div class="hot-topic-content">
            <h4 class="hot-topic-title">{{ decode(article.title) }}</h4>
            <p class="hot-topic-description">{{ decode(article.field_short_description) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="previous-comments-section">
      <h3>Previous Comments</h3>
      <div *ngFor="let comment of previousComments" class="comment-item">
        <div class="comment-header">
          <span class="comment-username">{{ comment.userName }}</span>
          <span class="comment-datetime">{{ comment.dateTime | date:'medium' }}</span>
        </div>
        <p class="comment-text">{{ comment.commentText }}</p>
      </div>
      <div *ngIf="previousComments.length === 0" class="no-comments-message">
        No comments yet. Be the first to comment!
      </div>
    </div>
  </div>
</div>



